import lodash from 'lodash';

const newInboxSelectors = {
    getTasks: state => state.tasks || [],
    getTasksCount: state => state.tasksCount || [],
    getTasksStudyBinderNames: state => state.myTasksStudyBinderNames || [],
    //getBinderStudies: state => state.dashboard.binderStudies.studiesAndBinders || [],
    getTasksFetching: state => state.tasksFetching,
    getTasksSigning: state => state.tasksSigning,
    getTasksForMultiSign: state => state.tasksForMultiSign || [],
    getTaskForSingleSign: state => state.taskForSingleSign || {},
    getTaskForDetailDisplay: state => state.taskForDetailDisplay || {},
    getTaskDetail: state => state.taskDetail || {},
    getView: state => state.view,
    getTaskDetailFetching: state => state.taskDetailFetching,
    getOriginUrl: state => lodash.get(state, 'application.config.corsOriginUrl', undefined)
};

export default newInboxSelectors;
